function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('.analytics--potential-sign-in').forEach((element) => {
  element.addEventListener('click', () => {
    const pendingEvents = JsonCookies.get(`pending_events`) || {};

    JsonCookies.set('_bevmo_new_customer', true);
    JsonCookies.set(`pending_events`, {
      ...pendingEvents,
      signed_in: {},
    });
  });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
let lastTrapFocusArgs = [];

function reTrapFocus() {
  // trapFocus doesn't update its list of elements
  // use when you've rendered content and need to add more focusable elements
  if (!lastTrapFocusArgs[0]) { return; }

  trapFocus(lastTrapFocusArgs[0], document.activeElement);
}

function trapFocus(container, elementToFocus = container) {
  lastTrapFocusArgs = [container, elementToFocus];
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

const navKeys = [
  'ARROWUP',
  'ARROWDOWN',
  'ARROWLEFT',
  'ARROWRIGHT',
  'TAB',
  'ENTER',
  'SPACE',
  'ESCAPE',
  'HOME',
  'END',
  'PAGEUP',
  'PAGEDOWN',
];

const setIsUsingNavKeys = (event) => {
  if (navKeys.includes(event?.code?.toUpperCase()) && event?.target?.tagName?.toUpperCase() !== 'INPUT') {
    document.body.classList.add(`state--enhanced-accessibility`);
    document.removeEventListener(`keydown`, setIsUsingNavKeys);
  }
};

document.addEventListener(`keydown`, setIsUsingNavKeys);

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

const globalMoneyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const toastDefaultSettings = {
  duration: -1,
  close: true,
  gravity: "bottom", // `top` or `bottom`
  position: "center", // `left`, `center` or `right`
  stopOnFocus: true, // Prevents dismissing of toast on hover
};

function toast(params) {
  const {
    message = ``,
    className = ``,
    settings = { ...toastDefaultSettings },
    showIcon = false,
    onReload = false,
    clearUrl = false,
  } = params;

  if (clearUrl) {
    const urlWithoutToast = new URL(location.href);

    urlWithoutToast.searchParams.delete(`toast`);
    history.replaceState(history.state, ``, urlWithoutToast);
  } else if (onReload) {
    const urlWithToast = new URL(location.href);

    urlWithToast.searchParams.set(`toast`, encodeURIComponent(JSON.stringify(params)));
    window.location.href = String(urlWithToast);

    return;
  }

  const node = document.createElement(`div`);
  const textNode = document.createElement(`div`);

  if (showIcon) {
    const iconNode = document.createElement(`div`);
    iconNode.classList.add(`toast__icon`);
    iconNode.innerHTML = `
      <svg 
      class="icon icon-error"   
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      viewBox="0 0 24 24" 
      fill="none"
      >
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>
      <path d="M12 7.5V12.75" stroke="currentColor" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
      <path d="M12 17.25C12.6213 17.25 13.125 16.7463 13.125 16.125C13.125 15.5037 12.6213 15 12 15C11.3787 15 10.875 15.5037 10.875 16.125C10.875 16.7463 11.3787 17.25 12 17.25Z" fill="currentColor"/>
      </svg>`;

    node.appendChild(iconNode);
  }

  node.classList.add(`toast__content`);
  textNode.classList.add(`toast__text`);
  textNode.innerHTML = message;
  node.appendChild(textNode);

  Toastify({
    node,
    className,
    ...settings,
  }).showToast();
}

function showOnLoadToast() {
  let url = new URL(location.href);
  const toastQueryParam = url.searchParams.get(`toast`);

  if (!toastQueryParam) { return; }

  const toastParams = JSON.parse(decodeURIComponent(toastQueryParam));
  toast({ ...toastParams, clearUrl: true });
}

showOnLoadToast();

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.mouseDownTarget = null;
    this.modalIsSet = this.dataset.isSet;

    const modalCloseEls = this.querySelectorAll('[id^="ModalClose-"]');
    if (modalCloseEls.length > 0) {
      modalCloseEls.forEach((modalCloseEl) => {
        modalCloseEl.addEventListener('click', this.hide.bind(this, false));
      });
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('mousedown', (event) => {
        this.mouseDownTarget = event.target;
      });
      this.addEventListener('mouseup', (event) => {
        if (event.target === this && event.target === this.mouseDownTarget) {
          this.hide();
        }
      });
    }
  }

  connectedCallback() {
    if (this.moved || this.modalIsSet) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  getIsModalOpen() {
    return this.hasAttribute('open');
  }

  show(opener, setFocus = true, fullTakeover = true) {
    if (this.getAttribute(`id`) === `SearchModal`) {
      const cartDrawer = document.querySelector(`cart-drawer`);
      if (cartDrawer) {
        cartDrawer.close();
      }
    }

    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    if (fullTakeover) document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    if (setFocus) trapFocus(this, this.querySelector('[role="dialog"], [role="combobox"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    if (this.getAttribute(`id`) === `SearchModal`) {
      const bottomNav = document.querySelector(`bottom-nav`);
      if (bottomNav) {
        bottomNav.fallbackBottomItems();
      }
    }
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class BottomNav extends HTMLElement {
  constructor() {
    super();

    this.bottomBanner = this.querySelector(`.bottom-nav__banner`);
    this.menuToggle = this.querySelector(`[bottom-nav-item="menu"]`);

    this.setActiveBottomItem = this.setActiveBottomItem.bind(this);
    this.setBannerSession = this.setBannerSession.bind(this);
  }

  fallbackBottomItems() {
    // Check cart
    const cartDrawer = document.querySelector(`cart-drawer`);
    if (cartDrawer && cartDrawer.classList.contains(`active`)) {
      this.setActiveBottomItem(`cart`);
      return;
    }

    // Check search
    const searchModal = document.querySelector(`.search-modal--dialog`);
    if ((searchModal && searchModal.getAttribute(`open`) !== null) || window.location.pathname.indexOf(`/search`) === 0) {
      this.setActiveBottomItem(`search`);
      return;
    }

    // Check menu drawer
    const headerDrawer = document.querySelector(`header-drawer`);
    if (headerDrawer && headerDrawer.querySelector(`details`).getAttribute(`open`) !== null && document.querySelector(`[bottom-nav-item="menu"]`)) {
      this.setActiveBottomItem(`menu`);
      return;
    }

    // Check account
    if (window.location.pathname.indexOf(`/account`) === 0) {
      this.setActiveBottomItem(`account`);
      return;
    }

    // Check home
    if (window.location.pathname === `/`) {
      this.setActiveBottomItem(`home`);
      return;
    }

    // Deselect all items
    this.querySelectorAll(`.bottom-nav__list-item--active`).forEach((item) => {
      item.classList.remove(`bottom-nav__list-item--active`);
    });
  }

  setActiveBottomItem(name) {
    this.querySelectorAll(`[bottom-nav-item]`).forEach((item) => {
      if (item.getAttribute(`bottom-nav-item`) === name) {
        item.classList.add(`bottom-nav__list-item--active`);
      } else {
        item.classList.remove(`bottom-nav__list-item--active`);
      }
    });
  }

  setBannerSession() {
    const heading = this.bottomBanner.querySelector(`.bottom-nav__banner-heading`);
    const body = this.bottomBanner.querySelector(`.bottom-nav__banner-body`);
    const data = {
      heading: heading && heading.textContent,
      body: body && body.textContent
    };

    sessionStorage.setItem(`bottomBanner`, JSON.stringify(data));
    document.body.style.removeProperty(`--bottom-nav-height`);
  }

  setBannerVisibility() {
    if (!this.bottomBanner) return;

    const sessionBannerData = sessionStorage.bottomBanner ? JSON.parse(sessionStorage.bottomBanner) : {};
    const heading = this.bottomBanner.querySelector(`.bottom-nav__banner-heading`);
    const body = this.bottomBanner.querySelector(`.bottom-nav__banner-body`);
    const headingText = heading && heading.textContent;
    const bodyText = body && body.textContent;

    if (sessionBannerData && sessionBannerData.heading === headingText && sessionBannerData.body === bodyText) return;

    this.bottomBanner.show(null, false, false);
    document.body.style.setProperty(`--bottom-nav-height`, `${this.offsetHeight}px`);
  }

  setUserAgent() {
    const isApp = window.navigator.userAgent.includes(`BevMoApp`);

    if (isApp) return;
    this.classList.add(`bottom-nav--web`);
  }

  addEvents() {
    this.querySelectorAll(`[bottom-nav-item]`).forEach((item) => {
      item.addEventListener(`click`, (event) => {
        this.setActiveBottomItem(event.currentTarget.getAttribute(`bottom-nav-item`));
      });
    });

    if (this.menuToggle) {
      this.menuToggle.addEventListener(`click`, (event) => {
        const headerDrawer = document.querySelector(`header-drawer`);
        if (!headerDrawer) return;

        const details = headerDrawer.querySelector(`details`);
        const isOpen = details.getAttribute(`open`) !== null;
        if (isOpen) {
          headerDrawer.closeMenuDrawer(event, headerDrawer.querySelector(`summary`));
        } else {
          headerDrawer.openMenuDrawer(headerDrawer.querySelector(`summary`));
        }
      });
    }

    if (this.bottomBanner) {
      this.bottomBanner.querySelector(`button`).addEventListener(`click`, this.setBannerSession);
    }
  }

  connectedCallback() {
    this.addEvents();
    this.setBannerVisibility();
    this.setUserAgent();
  }
}

customElements.define(`bottom-nav`, BottomNav);
